(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3021],{

/***/ 39844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sM": function() { return /* binding */ getSearchSuggestionList; },
/* harmony export */   "vz": function() { return /* binding */ getCityList; }
/* harmony export */ });
/* unused harmony exports getPartners, getExchangeRates */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58081);



var getSearchSuggestionList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(query) {
        var data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (query.length < 3) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/search/".concat(query))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getSearchSuggestionList(query) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Get list of suggestions for cities
 *
 * @param query string possible city string
 * @returns SearchQueryResult
 */ var getCityList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(query) {
        var data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!query) {
                        return [
                            2,
                            []
                        ];
                    }
                    if (query.length < 3) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/cities/search/".concat(query))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getCityList(query) {
        return _ref.apply(this, arguments);
    };
}();
var getPartners = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/partners")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getPartners() {
        return _ref.apply(this, arguments);
    };
}();
var getExchangeRates = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("currencies/exchange-rates")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getExchangeRates() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 34520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SearchableField_SearchableFieldContainer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./hooks/useDebounce.ts
var useDebounce = __webpack_require__(4841);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/container/Container.tsx
var Container = __webpack_require__(93375);
// EXTERNAL MODULE: ./components/TextField/TextField.tsx
var TextField = __webpack_require__(90943);
;// CONCATENATED MODULE: ./blocks/SearchableField/SuggestionList.tsx




var SuggestionList = function(param) {
    var setState = param.setState, name = param.name, onSelect = param.onSelect, state = param.state, shouldOpen = param.shouldOpen;
    var suggestionOptions = state.suggestionOptions, noResultsFound = state.noResultsFound, isLoading = state.isLoading;
    // Close suggestions when clicking outside of the search input
    (0,react.useEffect)(function() {
        var handleOutsideClick = function(event) {
            var target = event.target;
            if (target.name === name) {
                return;
            }
            setState(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    showDropDown: false
                });
            });
        };
        document.addEventListener("click", handleOutsideClick);
        return function() {
            document.removeEventListener("click", handleOutsideClick);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!shouldOpen || !suggestionOptions || isLoading) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "searchable-field__suggest-list",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            children: noResultsFound ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: "No results found"
            }) : suggestionOptions.map(function(option, index) {
                var suggestion = "".concat(option.name, ", ").concat(option.country);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    value: option.id,
                    onClick: function() {
                        return onSelect({
                            id: option.id,
                            name: suggestion
                        });
                    },
                    children: suggestion
                }, index);
            })
        })
    });
};
/* harmony default export */ var SearchableField_SuggestionList = (SuggestionList);

;// CONCATENATED MODULE: ./blocks/SearchableField/SearchableField.tsx







var SearchableField = function(_param) {
    var state = _param.state, props = (0,_object_without_properties/* default */.Z)(_param, [
        "state"
    ]);
    var setState = props.setState;
    var showDropDown = state.showDropDown, suggestionOptions = state.suggestionOptions, isLoading = state.isLoading;
    var reference = props.reference, name = props.name, label = props.label, value = props.value, errorMsg = props.errorMsg, onChange = props.onChange, onSelect = props.onSelect;
    var ctProps = props.ctProps;
    var handleFocus = function(e) {
        e.target.setAttribute("autocomplete", "new-password");
        setState(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                showDropDown: true
            });
        });
    };
    var shouldOpen = showDropDown && suggestionOptions && (value === null || value === void 0 ? void 0 : value.length) >= 3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        mt: ctProps === null || ctProps === void 0 ? void 0 : ctProps.mt,
        mb: ctProps === null || ctProps === void 0 ? void 0 : ctProps.mb,
        className: "searchable-field",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                inputRef: reference,
                label: label,
                name: name,
                value: value,
                onChange: onChange,
                inputClass: shouldOpen ? "searchable-field-results" : "",
                onFocus: handleFocus,
                errorMsg: shouldOpen ? "" : errorMsg
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchableField_SuggestionList, {
                value: value,
                name: name,
                setState: setState,
                state: state,
                onSelect: onSelect,
                shouldOpen: !!shouldOpen
            })
        ]
    });
};
/* harmony default export */ var SearchableField_SearchableField = (SearchableField);

;// CONCATENATED MODULE: ./blocks/SearchableField/SearchableFieldContainer.tsx








var SearchableFieldContainer = function(_param) {
    var name = _param.name, label = _param.label, value = _param.value, queryKey = _param.queryKey, queryFunction = _param.queryFunction, onChange = _param.onChange, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "value",
        "queryKey",
        "queryFunction",
        "onChange"
    ]);
    var initialState = {
        searchInputValue: (value === null || value === void 0 ? void 0 : value.name) || "",
        valueSelected: false,
        showDropDown: false,
        suggestionOptions: undefined,
        noResultsFound: false,
        isLoading: false
    };
    var ref = (0,react.useState)(initialState), state = ref[0], setState = ref[1];
    var generateKey = function() {
        return queryKey ? queryKey : name;
    };
    var handleChange = function(e) {
        var _target = e.target, searchInputValue = _target.value;
        setState(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                showDropDown: true,
                valueSelected: false,
                isLoading: true,
                searchInputValue: searchInputValue
            });
        });
        onChange({
            id: 0,
            name: searchInputValue
        });
    };
    var handleSelect = function(option) {
        setState(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                showDropDown: false,
                valueSelected: true
            });
        });
        onChange(option);
    };
    var handleOnReset = function() {
        setState(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                valueSelected: false,
                searchInputValue: "",
                noResultsFound: false,
                isLoading: false
            });
        });
    };
    // debounce the search value to avoid unnecessary api calls
    var searchTerm = (0,useDebounce/* default */.Z)((value === null || value === void 0 ? void 0 : value.name) || "", 200);
    // fetch the search suggestion list
    var data = (0,useQuery/* useQuery */.a)([
        generateKey(),
        searchTerm
    ], function() {
        return queryFunction(searchTerm);
    }, {
        staleTime: 1000 * 60
    }).data;
    //sync the data state with the current context state
    (0,react.useEffect)(function() {
        setState(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                suggestionOptions: data,
                noResultsFound: (data === null || data === void 0 ? void 0 : data.length) === 0,
                isLoading: false
            });
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchableField_SearchableField, (0,_object_spread/* default */.Z)({
        label: label,
        name: name,
        state: state,
        setState: setState,
        onChange: handleChange,
        onSelect: handleSelect,
        onReset: handleOnReset,
        value: (value === null || value === void 0 ? void 0 : value.name) || ""
    }, props));
};
/* harmony default export */ var SearchableField_SearchableFieldContainer = (SearchableFieldContainer);


/***/ }),

/***/ 46050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var _RadioButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92661);






var ControlledRadioButton = function(props) {
    var name = props.name, value = props.value, _onPostChange = props.onPostChange, onPostChange = _onPostChange === void 0 ? function() {} : _onPostChange;
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useController */ .bc)({
        name: name,
        defaultValue: value
    }), field = ref.field, error = ref.fieldState.error;
    var handleChange = function(name, value) {
        field.onChange(value);
        onPostChange();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RadioButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props, field), {
        onRadioButtonClick: handleChange,
        errorMsg: error === null || error === void 0 ? void 0 : error.message
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ControlledRadioButton);


/***/ }),

/***/ 92661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Radio__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45993);
/* harmony import */ var _mui_material_RadioGroup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68061);
/* harmony import */ var _mui_material_FormControlLabel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20847);
/* harmony import */ var components_icons_RadioCheckedIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81440);
/* harmony import */ var components_icons_RadioIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10604);
/* harmony import */ var _RadioButton_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93636);
/* harmony import */ var _RadioButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_RadioButton_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var components_text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22538);









var RadioButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function RadioButtonWithRef(param, ref) {
    var name = param.name, value = param.value, options = param.options, onRadioButtonClick = param.onRadioButtonClick, errorMsg = param.errorMsg, className = param.className;
    var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        onRadioButtonClick(name, value);
    }, [
        name,
        onRadioButtonClick
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_RadioGroup__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                ref: ref,
                "aria-labelledby": "radio-buttons-group-label",
                name: "radio-buttons-group",
                value: value !== null && value !== void 0 ? value : "",
                onChange: function(e) {
                    return handleChange(e.target.value);
                },
                className: (_RadioButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default().radioContainer),
                children: options.map(function(option) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_FormControlLabel__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: "".concat((_RadioButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default().radioButton), " ").concat(errorMsg && (_RadioButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default().error)),
                        value: option.value,
                        control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Radio__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_icons_RadioIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                            checkedIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_icons_RadioCheckedIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                        }),
                        label: option.label
                    }, option.value);
                })
            }),
            errorMsg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_text__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT, {
                color: "forms-red",
                children: errorMsg
            })
        ]
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (RadioButton);


/***/ }),

/***/ 61339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ControlledSelect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var _Select__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80434);






var ControlledSelect = function(props) {
    var name = props.name, defaultValue = props.defaultValue;
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useController */ .bc)({
        name: name
    }), _field = ref.field, onChange = _field.onChange, value = _field.value;
    var handleChange = function(name, value) {
        onChange(value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        onChange: handleChange,
        value: value || defaultValue
    }));
};


/***/ }),

/***/ 80434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Select; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(69397);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js
var Menu = __webpack_require__(24486);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(63931);
;// CONCATENATED MODULE: ./hooks/useBodyScrollLock.ts

var useBodyScrollLock = function() {
    var originalPaddingRight = (0,react.useRef)(null);
    var originalTop = (0,react.useRef)(0);
    var isLocked = (0,react.useRef)(false);
    var disableScroll = function() {
        if (false) {}
        // Check if body already has overflow hidden
        if (window.getComputedStyle(document.body).overflow === "hidden") {
            isLocked.current = false; // Indicate that the hook didn't lock the scroll
            return;
        }
        // Save the current scroll position
        originalTop.current = window.scrollY;
        // Add padding to prevent layout shift due to scrollbar disappearance
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        originalPaddingRight.current = document.body.style.paddingRight;
        if (scrollBarGap > 0) {
            document.body.style.paddingRight = "".concat(scrollBarGap, "px");
        }
        // Lock scroll using `position: fixed` and save the scroll offset in `top`
        document.body.style.position = "fixed";
        document.body.style.top = "-".concat(originalTop.current, "px");
        document.body.style.left = "0";
        document.body.style.width = "100%";
        isLocked.current = true;
    };
    var enableScroll = function() {
        if ( false || !isLocked.current) return;
        // Get the original scroll position from the `top` property
        var scrollY = Math.abs(parseInt(document.body.style.top || "0", 10));
        // Temporarily disable scroll animation
        var originalScrollBehavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = "auto";
        // Restore original styles
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.left = "";
        document.body.style.width = "";
        if (originalPaddingRight.current !== null) {
            document.body.style.paddingRight = originalPaddingRight.current;
        }
        // Restore the scroll position without animation
        window.scrollTo(0, scrollY);
        // Restore the original scroll-behavior
        document.documentElement.style.scrollBehavior = originalScrollBehavior || "";
        isLocked.current = false;
    };
    return {
        disableScroll: disableScroll,
        enableScroll: enableScroll
    };
};
/* harmony default export */ var hooks_useBodyScrollLock = (useBodyScrollLock);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/icons/ArrowDown.tsx
var ArrowDown = __webpack_require__(91441);
// EXTERNAL MODULE: ./components/icons/ArrowUp.tsx
var ArrowUp = __webpack_require__(29661);
;// CONCATENATED MODULE: ./components/Select/Select.tsx










function Select(param) {
    var label = param.label, value = param.value, name = param.name, options = param.options, onChange = param.onChange, _upperCaseOptions = param.upperCaseOptions, upperCaseOptions = _upperCaseOptions === void 0 ? false : _upperCaseOptions, _layout = param.layout, layout = _layout === void 0 ? "FORM" : _layout;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), anchorEl = ref[0], setAnchorEl = ref[1];
    var ref1 = hooks_useBodyScrollLock(), disableScroll = ref1.disableScroll, enableScroll = ref1.enableScroll;
    var open = Boolean(anchorEl);
    var handleMenuOpen = function(event) {
        setAnchorEl(event.currentTarget);
        disableScroll();
    };
    var handleClose = function() {
        setAnchorEl(null);
        enableScroll();
    };
    var handleSelect = function(selectedValue) {
        onChange(name, selectedValue);
        handleClose();
    };
    var getPresentedValue = function() {
        var selectedOption = options.find(function(option) {
            return option.value === value;
        });
        return (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.name) || (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.html) || value;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "select-container".concat(open ? " select-container--open" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "select-container__label",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                id: "basic-button",
                disableRipple: true,
                className: classnames_default()({
                    "form-layout": layout === "FORM",
                    "currency-layout": layout === "CURRENCY"
                }),
                onClick: handleMenuOpen,
                endIcon: open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* default */.Z, {
                    width: 12,
                    height: 6
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                    width: 12,
                    height: 6
                }),
                children: getPresentedValue()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                MenuListProps: {
                    sx: {
                        borderTop: "1px solid #000",
                        minWidth: "140px"
                    }
                },
                children: options.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        disableRipple: true,
                        selected: option.value === value,
                        onClick: function() {
                            return handleSelect(option.value);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                textTransform: upperCaseOptions ? "uppercase" : "none"
                            },
                            children: option.name || option.html || option.value
                        })
                    }, option.value);
                })
            })
        ]
    });
}


/***/ }),

/***/ 17073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ ControlledTextField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87536);
/* harmony import */ var _TextField__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90943);






var ControlledTextField = function(_param) {
    var rules = _param.rules, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "rules"
    ]);
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .useFormContext */ .Gc)(), control = ref.control, clearErrors = ref.clearErrors;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return function() {
            clearErrors(props.name);
        };
    }, [
        clearErrors,
        props.name
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .Controller */ .Qr, {
        name: props.name,
        defaultValue: "",
        control: control,
        rules: rules,
        render: function(param) {
            var field = param.field, error = param.fieldState.error;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                errorMsg: error === null || error === void 0 ? void 0 : error.message
            }, field, props));
        }
    });
};


/***/ }),

/***/ 4841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useDebounce = function(value) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        return function() {
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
};
/* harmony default export */ __webpack_exports__["Z"] = (useDebounce);


/***/ }),

/***/ 93636:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radioContainer":"RadioButton_radioContainer__PA7O8","radioButton":"RadioButton_radioButton__Sd7OI","error":"RadioButton_error__n4cO5"};

/***/ })

}]);